/** Средняя абсолютная амплитуда по временным корзинам, нормированная на максимум. */
export function computePeaks(raw: Float32Array, bars = 38): number[] {
  const sums = Array<number>(bars).fill(0);
  const counts = Array<number>(bars).fill(0);
  for (let i = 0; i < raw.length; i++) {
    const bin = Math.min(bars - 1, Math.floor(i * bars / raw.length));
    sums[bin] += Math.abs(raw[i]);
    counts[bin]++;
  }
  const averages = sums.map((sum, i) => counts[i] ? sum / counts[i] : 0);
  const max = Math.max(...averages, 0.0001);
  return averages.map((value) => Math.max(0.12, value / max));
}
